module.exports = __webpack_public_path__ + "static/media/item2.11288e54.jpg";